import { createEntityAdapter, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { loadProjectConfiguration } from './thunks/loadProjectConfiguration.thunk';
import { setProjectConfiguration } from './thunks/setProjectConfiguration';

const projectConfigurationsSlice = createSlice({
  name: 'projectConfigurations',
  initialState: {
    projectConfigurations: {},
    loadingProjectConfiguration: false,
    error: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(loadProjectConfiguration.pending, (state) => {
        state.loadingProjectConfiguration = true;
      })
      .addCase(loadProjectConfiguration.fulfilled, (state, action) => {
        const projectId = action.payload?.projectId;
        const projectConfiguration = action.payload?.projectConfiguration ?? null;

        if (projectId) {
          state.projectConfigurations[projectId] = projectConfiguration;
        }
        state.loadingProjectConfiguration = false;
      })
      .addCase(loadProjectConfiguration.rejected, (state, action) => {
        state.loadingProjectConfiguration = false;
        state.error = action.error;
      })
      .addCase(setProjectConfiguration.pending, (state) => ({
        ...state,
        loadingProjectConfiguration: true,
      }))
      .addCase(setProjectConfiguration.fulfilled, (state, action) => {
        console.log(" action:", action)
        state.projectConfigurations[action.payload.project] = action.payload;
        state.loadingProjectConfiguration = false;
      })
      .addCase(setProjectConfiguration.rejected, (state, action) => ({
        ...state,
        error: action.error,
        loadingProjectConfiguration: false,
      }))
  },
});

export default projectConfigurationsSlice.reducer;
